(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-fridge-filter-pdp"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ff-fridge-pdp').forEach((section) => {
    const heroImage = section.querySelector('.ff-fridge-pdp__hero-image');
    const galleryThumbs = section.querySelectorAll('.ff-fridge-pdp__thumb[data-full-image]');
    const thumbTrack = section.querySelector('[data-ff-thumbs-track]');
    const thumbPrev = section.querySelector('[data-ff-thumbs-prev]');
    const thumbNext = section.querySelector('[data-ff-thumbs-next]');
    const preloadImage = (url) => {
      if (!url) {
        return;
      }
      const image = new Image();
      image.src = url;
    };

    const updateThumbButtons = () => {
      if (!thumbTrack || !thumbPrev || !thumbNext) {
        return;
      }

      const isHorizontal = window.getComputedStyle(thumbTrack).flexDirection === 'row';
      const maxScroll = isHorizontal
        ? thumbTrack.scrollWidth - thumbTrack.clientWidth
        : thumbTrack.scrollHeight - thumbTrack.clientHeight;
      const currentScroll = isHorizontal ? thumbTrack.scrollLeft : thumbTrack.scrollTop;
      const canScroll = maxScroll > 2;
      const thumbs = thumbTrack.closest('.ff-fridge-pdp__thumbs');
      if (thumbs) {
        thumbs.classList.toggle('has-overflow', canScroll);
      }
      thumbPrev.hidden = !canScroll;
      thumbNext.hidden = !canScroll;
      thumbPrev.disabled = !canScroll || currentScroll <= 2;
      thumbNext.disabled = !canScroll || currentScroll >= maxScroll - 2;
    };

    if (thumbTrack && thumbPrev && thumbNext) {
      const scrollThumbs = (direction) => {
        const firstThumb = thumbTrack.querySelector('.ff-fridge-pdp__thumb');
        const isHorizontal = window.getComputedStyle(thumbTrack).flexDirection === 'row';
        const step = firstThumb
          ? (isHorizontal ? firstThumb.offsetWidth : firstThumb.offsetHeight) + 10
          : 104;
        thumbTrack.scrollBy({
          top: isHorizontal ? 0 : step * direction,
          left: isHorizontal ? step * direction : 0,
          behavior: 'smooth'
        });
      };

      thumbPrev.addEventListener('click', () => scrollThumbs(-1));
      thumbNext.addEventListener('click', () => scrollThumbs(1));
      thumbTrack.addEventListener('scroll', updateThumbButtons, { passive: true });
      window.addEventListener('resize', updateThumbButtons);
      requestAnimationFrame(updateThumbButtons);
    }

    galleryThumbs.forEach((thumb) => {
      preloadImage(thumb.dataset.fullImage);
      preloadImage(thumb.dataset.zoomImage);
      thumb.addEventListener('click', () => {
        setHeroImage(thumb.dataset.fullImage, thumb.dataset.zoomImage, thumb.dataset.alt, thumb.dataset.mediaId);
      });
    });

    const zoomButton = section.querySelector('.ff-fridge-pdp__zoom');
    const zoomModal = section.querySelector('[data-ff-zoom-modal]');
    const zoomImage = section.querySelector('[data-ff-zoom-image]');
    const zoomClose = section.querySelector('[data-ff-zoom-close]');
    const setHeroImage = (imageUrl, zoomUrl, alt, mediaId) => {
      if (!heroImage || !imageUrl) {
        return;
      }

      heroImage.removeAttribute('srcset');
      heroImage.removeAttribute('sizes');
      heroImage.src = imageUrl;
      if (alt) {
        heroImage.alt = alt;
      }
      if (zoomImage) {
        zoomImage.dataset.ffZoomSrc = zoomUrl || imageUrl;
        zoomImage.removeAttribute('src');
        zoomImage.alt = alt || heroImage.alt || '';
      }

      section.querySelectorAll('.ff-fridge-pdp__thumb').forEach((item) => {
        const isActive = mediaId && item.dataset.mediaId === mediaId;
        item.classList.toggle('is-active', Boolean(isActive));
        if (isActive) {
          item.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
      updateThumbButtons();
    };
    const closeZoom = () => {
      if (zoomModal) {
        zoomModal.setAttribute('hidden', '');
      }
      document.documentElement.style.overflow = '';
    };

    if (zoomButton && zoomModal && zoomImage && heroImage) {
      const centerZoomImage = () => {
        requestAnimationFrame(() => {
          zoomModal.scrollLeft = Math.max(0, (zoomImage.offsetWidth - zoomModal.clientWidth) / 2);
          zoomModal.scrollTop = 0;
        });
      };

      const openZoom = () => {
        const zoomSource = zoomImage.dataset.ffZoomSrc || heroImage.currentSrc || heroImage.src;
        if (zoomSource) {
          zoomImage.src = zoomSource;
        }
        zoomImage.alt = heroImage.alt || '';
        zoomModal.removeAttribute('hidden');
        document.documentElement.style.overflow = 'hidden';
        centerZoomImage();
      };

      zoomButton.addEventListener('click', openZoom);
      heroImage.addEventListener('dblclick', openZoom);

      zoomImage.addEventListener('load', centerZoomImage);

      zoomModal.addEventListener('click', (event) => {
        if (event.target === zoomModal) {
          closeZoom();
        }
      });

      if (zoomClose) {
        zoomClose.addEventListener('click', closeZoom);
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !zoomModal.hasAttribute('hidden')) {
          closeZoom();
        }
      });
    }

    const price = section.querySelector('[data-ff-price]');
    const stock = section.querySelector('[data-ff-stock]');
    const stockLabel = section.querySelector('[data-ff-stock-label]');
    const stockCopy = section.querySelector('[data-ff-stock-copy]');
    const addToBasket = section.querySelector('.ff-fridge-pdp__atb');
    const addToBasketText = addToBasket ? addToBasket.querySelector('span') : null;
    const updateStock = (available) => {
      if (stock) {
        stock.classList.toggle('ff-fridge-pdp__stock--unavailable', !available);
      }
      if (stockLabel) {
        stockLabel.textContent = available ? 'In stock' : 'Out of stock';
      }
      if (stockCopy) {
        stockCopy.textContent = available ? 'Ready to dispatch' : 'Choose another pack';
      }
      if (addToBasket) {
        addToBasket.disabled = !available;
      }
      if (addToBasketText) {
        addToBasketText.textContent = available ? 'Add to Basket' : 'Sold out';
      }
    };

    section.querySelectorAll('.ff-fridge-pdp__pack input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => {
        section.querySelectorAll('.ff-fridge-pdp__pack').forEach((pack) => pack.classList.remove('is-selected'));
        input.closest('.ff-fridge-pdp__pack').classList.add('is-selected');
        if (price && input.dataset.price) {
          price.textContent = input.dataset.price;
        }
        setHeroImage(input.dataset.fullImage, input.dataset.zoomImage, input.dataset.alt, input.dataset.mediaId);
        updateStock(input.dataset.available !== 'false');
      });
    });

    section.querySelectorAll('.ff-fridge-pdp__qty').forEach((qty) => {
      const input = qty.querySelector('input');
      const minus = qty.querySelector('[data-ff-qty-minus]');
      const plus = qty.querySelector('[data-ff-qty-plus]');
      minus.addEventListener('click', () => {
        input.value = Math.max(1, Number(input.value || 1) - 1);
      });
      plus.addEventListener('click', () => {
        input.value = Number(input.value || 1) + 1;
      });
    });

    const compat = section.querySelector('.ff-fridge-pdp__compat');
    if (compat) {
      const input = compat.querySelector('[data-ff-model-input]');
      const button = compat.querySelector('[data-ff-model-check]');
      const result = compat.querySelector('[data-ff-model-result]');
      const modelDataScript = compat.querySelector('[data-ff-compat-models]');
      const filterIndexScript = compat.querySelector('[data-ff-compat-filter-index]');
      const productForm = section.querySelector('.ff-fridge-pdp__form');
      const currentProductId = String(compat.dataset.productId || '');
      const currentProductTitle = compat.dataset.productTitle || document.title || '';
      const currentProductUrl = compat.dataset.productUrl || window.location.pathname;
      const filterIndexUrl = compat.dataset.filterIndexUrl || '';
      const compatibilityLogEndpoint = compat.dataset.compatLogEndpoint || '';
      let confirmedApplianceModel = '';
      let confirmedApplianceData = null;
      const parseJsonScript = (script, fallback) => {
        if (!script) {
          return fallback;
        }
        try {
          const parsed = JSON.parse(script.textContent || '[]');
          return Array.isArray(parsed) ? parsed : fallback;
        } catch (error) {
          return fallback;
        }
      };
      const sanitizeModelEntry = (entry) => ({
        model: entry && entry.model ? String(entry.model) : '',
        brand: entry && entry.brand ? String(entry.brand) : '',
        family: entry && entry.family ? String(entry.family) : '',
        aliases: entry && Array.isArray(entry.aliases) ? entry.aliases.map((alias) => String(alias || '')).filter(Boolean) : []
      });
      const compatibleModelEntries = parseJsonScript(modelDataScript, []).map(sanitizeModelEntry).filter((entry) => entry.model || entry.aliases.length);
      const normalizeFilterIndex = (parsedIndex) => {
        if (!Array.isArray(parsedIndex)) {
          return [];
        }
        return parsedIndex.map((filterProduct) => {
          const models = Array.isArray(filterProduct.models) ? filterProduct.models.map(sanitizeModelEntry).filter((entry) => entry.model || entry.aliases.length) : [];
          return {
            productId: filterProduct.productId ? String(filterProduct.productId) : '',
            variantId: filterProduct.variantId ? String(filterProduct.variantId) : '',
            title: filterProduct.title ? String(filterProduct.title) : '',
            url: filterProduct.url ? String(filterProduct.url) : '',
            sku: filterProduct.sku ? String(filterProduct.sku) : '',
            price: filterProduct.price ? String(filterProduct.price) : '',
            image: filterProduct.image ? String(filterProduct.image) : '',
            imageAlt: filterProduct.imageAlt ? String(filterProduct.imageAlt) : '',
            available: filterProduct.available !== false,
            models
          };
        }).filter((filterProduct) => filterProduct.productId && filterProduct.url && filterProduct.models.length);
      };
      const parseFilterIndex = () => normalizeFilterIndex(parseJsonScript(filterIndexScript, []));
      let filterIndex = parseFilterIndex();
      let filterIndexReady = Promise.resolve(filterIndex);
      if (filterIndexUrl && window.fetch) {
        filterIndexReady = fetch(filterIndexUrl, { credentials: 'same-origin' })
          .then((response) => response.ok ? response.json() : [])
          .then((assetIndex) => {
            const normalizedIndex = normalizeFilterIndex(assetIndex);
            if (normalizedIndex.length) {
              filterIndex = normalizedIndex;
            }
            return filterIndex;
          })
          .catch(() => filterIndex);
      }
      const escapeHtml = (value) => {
        const escapeTarget = document.createElement('span');
        escapeTarget.textContent = String(value || '');
        return escapeTarget.innerHTML;
      };
      const setResult = (message, state) => {
        if (!result) {
          return;
        }
        result.classList.remove('is-compatible', 'is-incompatible', 'is-warning');
        if (state) {
          result.classList.add(state);
        }
        result.textContent = message;
      };
      const setResultHtml = (messageHtml, state) => {
        if (!result) {
          return;
        }
        result.classList.remove('is-compatible', 'is-incompatible', 'is-warning');
        if (state) {
          result.classList.add(state);
        }
        result.innerHTML = messageHtml;
      };
      const buildStatusHtml = (heading, copy, icon = '✓') => `
        <div class="ff-fridge-pdp__compat-status">
          <span class="ff-fridge-pdp__compat-status-icon" aria-hidden="true">${icon}</span>
          <div>
            <h3>${heading}</h3>
            <p>${copy}</p>
          </div>
        </div>
      `;
      const buildCorrectFilterHtml = (filterProduct, matchedModel, isFuzzyMatch, modelBrand = '') => {
        const productTitle = escapeHtml(filterProduct.title || 'the correct filter');
        const productUrl = escapeHtml(filterProduct.url || '/collections/fridge-filters');
        const productVariantId = escapeHtml(filterProduct.variantId || '');
        const productSku = escapeHtml(filterProduct.sku || '');
        const productBrand = escapeHtml(modelBrand || '');
        const hasProductImage = Boolean(filterProduct.image);
        const productImage = escapeHtml(filterProduct.image || '');
        const productImageAlt = escapeHtml(filterProduct.imageAlt || filterProduct.title || '');
        const productPrice = escapeHtml(filterProduct.price || '');
        const modelCopy = escapeHtml(matchedModel || '');
        const intro = isFuzzyMatch
          ? `Did you mean <strong>${modelCopy}</strong>? If so, this is the correct filter for that fridge model.`
          : `The fridge model <strong>${modelCopy}</strong> uses a different filter. This is the correct product for that model.`;
        return `
          ${buildStatusHtml('Correct filter found', intro, 'i')}
          <div class="ff-fridge-pdp__compat-product${hasProductImage ? '' : ' ff-fridge-pdp__compat-product--no-image'}">
            ${productImage ? `<img src="${productImage}" alt="${productImageAlt}" loading="lazy" width="78" height="78">` : ''}
            <div>
              <h4>${productTitle}</h4>
              ${productPrice ? `<p class="ff-fridge-pdp__compat-product-price">${productPrice}</p>` : ''}
              <div class="ff-fridge-pdp__compat-product-actions">
                ${productVariantId ? `<button class="ff-fridge-pdp__compat-product-action ff-fridge-pdp__compat-product-action--primary" type="button" data-ff-compat-add data-variant-id="${productVariantId}" data-model="${modelCopy}" data-brand="${productBrand}" data-sku="${productSku}">Add to basket</button>` : ''}
                <a class="ff-fridge-pdp__compat-product-action ff-fridge-pdp__compat-product-action--secondary" href="${productUrl}">View product</a>
              </div>
            </div>
          </div>
        `;
      };
      const ensureHiddenInput = (name) => {
        if (!productForm) {
          return null;
        }
        let hiddenInput = productForm.querySelector(`input[name="${name}"]`);
        if (!hiddenInput) {
          hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = name;
          productForm.appendChild(hiddenInput);
        }
        return hiddenInput;
      };
      const buildSlug = (brand, model) => {
        return `${brand.toLowerCase().trim()}:${model.toLowerCase().replace(/\s+/g, '').trim()}`;
      };
      const normalizeModel = (model) => {
        return model.replace(/\s+/g, '').trim();
      };
      const normalizeModelCode = (value) => {
        return String(value || '')
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]/gi, '')
          .toUpperCase();
      };
      const normalizeComparableCode = (value) => {
        return normalizeModelCode(value)
          .replace(/O/g, '0')
          .replace(/[IL]/g, '1');
      };
      const levenshteinDistance = (first, second) => {
        const a = first || '';
        const b = second || '';
        if (a === b) {
          return 0;
        }
        if (!a.length) {
          return b.length;
        }
        if (!b.length) {
          return a.length;
        }
        const previous = Array.from({ length: b.length + 1 }, (_, index) => index);
        const current = new Array(b.length + 1);
        for (let i = 1; i <= a.length; i += 1) {
          current[0] = i;
          for (let j = 1; j <= b.length; j += 1) {
            const cost = a[i - 1] === b[j - 1] ? 0 : 1;
            current[j] = Math.min(
              current[j - 1] + 1,
              previous[j] + 1,
              previous[j - 1] + cost
            );
          }
          for (let j = 0; j <= b.length; j += 1) {
            previous[j] = current[j];
          }
        }
        return previous[b.length];
      };
      const getCandidateValues = (entry) => {
        return [entry.model].concat(entry.aliases || []).filter(Boolean);
      };
      const scoreCandidate = (rawQuery, rawCandidate) => {
        const query = normalizeComparableCode(rawQuery);
        const candidate = normalizeComparableCode(rawCandidate);
        if (!query || !candidate || query.length < 4) {
          return null;
        }
        if (query === candidate) {
          return { score: 1, type: 'exact' };
        }
        if (query.length >= 5 && candidate.startsWith(query) && candidate.length - query.length <= 2) {
          return { score: 0.96, type: 'prefix' };
        }
        if (query.length >= 6 && candidate.includes(query)) {
          return { score: 0.93, type: 'partial' };
        }
        if (candidate.length >= 6 && query.includes(candidate)) {
          return { score: 0.91, type: 'contained' };
        }
        const queryTokens = String(rawQuery || '')
          .split(/[^a-z0-9]+/gi)
          .map((token) => normalizeComparableCode(token))
          .filter((token) => token.length >= 5);
        for (const token of queryTokens) {
          if (token === candidate) {
            return { score: 0.98, type: 'token' };
          }
          if (candidate.includes(token) || token.includes(candidate)) {
            return { score: 0.9, type: 'token-partial' };
          }
        }
        const maxDistance = query.length >= 8 && candidate.length >= 8 ? 2 : query.length >= 5 && candidate.length >= 5 ? 1 : 0;
        if (!maxDistance || Math.abs(query.length - candidate.length) > maxDistance) {
          return null;
        }
        const distance = levenshteinDistance(query, candidate);
        if (distance <= maxDistance) {
          return {
            score: 1 - distance / Math.max(query.length, candidate.length),
            type: 'fuzzy'
          };
        }
        return null;
      };
      const findCompatibleModel = (rawQuery, modelEntries = compatibleModelEntries, minimumScore = 0.82) => {
        let bestMatch = null;
        modelEntries.forEach((entry) => {
          getCandidateValues(entry).forEach((candidate) => {
            const candidateScore = scoreCandidate(rawQuery, candidate);
            if (!candidateScore) {
              return;
            }
            if (!bestMatch || candidateScore.score > bestMatch.score) {
              bestMatch = {
                entry,
                value: candidate,
                score: candidateScore.score,
                type: candidateScore.type
              };
            }
          });
        });
        return bestMatch && bestMatch.score >= minimumScore ? bestMatch : null;
      };
      const findFilterMatch = (rawQuery) => {
        let bestMatch = null;
        filterIndex.forEach((filterProduct) => {
          const productMatch = findCompatibleModel(rawQuery, filterProduct.models, 0.82);
          if (!productMatch) {
            return;
          }
          const titlePenalty = /opened|clearance|damaged|returned/i.test(filterProduct.title) ? 0.04 : 0;
          const availabilityPenalty = filterProduct.available ? 0 : 0.03;
          const adjustedScore = productMatch.score - titlePenalty - availabilityPenalty;
          const isCurrentProduct = filterProduct.productId === currentProductId;
          if (
            !bestMatch ||
            adjustedScore > bestMatch.adjustedScore ||
            (adjustedScore === bestMatch.adjustedScore && isCurrentProduct && bestMatch.product.productId !== currentProductId)
          ) {
            bestMatch = {
              ...productMatch,
              product: filterProduct,
              adjustedScore
            };
          }
        });
        return bestMatch;
      };
      const getSelectedVariantInput = () => {
        const selectedInput = section.querySelector('.ff-fridge-pdp__pack input[type="radio"]:checked');
        if (selectedInput) {
          return selectedInput;
        }
        return productForm ? productForm.querySelector('input[name="id"]') : null;
      };
      const getSelectedFilterSku = () => {
        const selectedInput = getSelectedVariantInput();
        return selectedInput ? selectedInput.dataset.sku || '' : '';
      };
      const getSelectedVariantId = () => {
        const selectedInput = getSelectedVariantInput();
        return selectedInput ? selectedInput.value || '' : '';
      };
      const buildApplianceData = (model, brandOverride = '', filterProduct = null) => {
        const brand = brandOverride || compat.dataset.applianceBrand || '';
        const category = compat.dataset.applianceCategory || 'fridge';
        const normalizedModel = normalizeModel(model);
        const filterSku = filterProduct && filterProduct.sku ? filterProduct.sku : getSelectedFilterSku();
        return {
          appliance_brand: brand.toLowerCase().trim(),
          appliance_model: normalizedModel,
          appliance_category: category.toLowerCase().trim(),
          appliance_slug: buildSlug(brand, normalizedModel),
          appliance_label: `${brand} ${normalizedModel}`.trim(),
          compatible_filter_sku: filterSku
        };
      };
      const setHiddenValue = (name, value) => {
        const hiddenInput = ensureHiddenInput(name);
        if (hiddenInput) {
          hiddenInput.value = value;
        }
      };
      const setApplianceFields = (data) => {
        setHiddenValue('properties[Fridge Model]', data.appliance_model);
        setHiddenValue('properties[_fridge_brand]', data.appliance_brand);
        setHiddenValue('properties[_fridge_appliance]', data.appliance_label);
        setHiddenValue('properties[_compatibility_status]', 'confirmed');
        setHiddenValue('properties[_compatibility_filter_sku]', data.compatible_filter_sku);
        setHiddenValue('attributes[fridge_model]', data.appliance_model);
        Object.keys(data).forEach((key) => {
          setHiddenValue(`attributes[${key}]`, data[key]);
        });
      };
      const clearApplianceFields = () => {
        confirmedApplianceModel = '';
        confirmedApplianceData = null;
        setHiddenValue('properties[Fridge Model]', '');
        setHiddenValue('properties[_fridge_brand]', '');
        setHiddenValue('properties[_fridge_appliance]', '');
        setHiddenValue('properties[_compatibility_status]', '');
        setHiddenValue('properties[_compatibility_filter_sku]', '');
        setHiddenValue('attributes[fridge_model]', '');
        [
          'appliance_brand',
          'appliance_model',
          'appliance_category',
          'appliance_slug',
          'appliance_label',
          'compatible_filter_sku'
        ].forEach((key) => {
          setHiddenValue(`attributes[${key}]`, '');
        });
      };
      const updateCartAttributes = (data) => {
        if (!data || !window.fetch) {
          return Promise.resolve();
        }
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        return fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: data
          }),
          credentials: 'same-origin'
        }).catch(() => {});
      };
      const updateCartApplianceAttributes = (data) => {
        return updateCartAttributes(data);
      };
      const updateCartCompatibilityAttributes = (payload) => {
        const matchedModel = payload.matched_model || payload.entered_model || '';
        const modelBrand = payload.appliance_brand || '';
        const compatibleFilterSku = payload.suggested_filter_sku || payload.compatible_filter_sku || payload.current_filter_sku || '';
        return updateCartAttributes({
          appliance_brand: modelBrand ? modelBrand.toLowerCase().trim() : '',
          appliance_model: matchedModel || '',
          appliance_category: matchedModel ? 'fridge' : '',
          appliance_slug: matchedModel ? buildSlug(modelBrand, matchedModel) : '',
          appliance_label: matchedModel ? `${modelBrand} ${matchedModel}`.trim() : '',
          compatible_filter_sku: compatibleFilterSku,
          last_fridge_model_check: payload.entered_model || '',
          last_fridge_model_result: payload.result || '',
          last_fridge_model_match: payload.matched_model || '',
          last_fridge_model_brand: payload.appliance_brand || '',
          last_fridge_checked_filter_sku: payload.current_filter_sku || '',
          last_fridge_compatible_filter_sku: compatibleFilterSku,
          last_fridge_suggested_filter_sku: payload.suggested_filter_sku || '',
          last_fridge_checked_product: payload.current_product_title || '',
          last_fridge_suggested_product: payload.suggested_product_title || '',
          last_fridge_suggested_product_url: payload.suggested_product_url || ''
        });
      };
      const logCompatibilitySubmission = (payload) => {
        const eventPayload = {
          event: 'fridge_compatibility_check',
          checked_at: new Date().toISOString(),
          page_path: window.location.pathname,
          page_url: window.location.href,
          current_product_id: currentProductId,
          current_product_title: currentProductTitle,
          current_product_url: currentProductUrl,
          current_variant_id: getSelectedVariantId(),
          current_filter_sku: getSelectedFilterSku(),
          ...payload
        };
        try {
          window.localStorage.setItem('ff_last_fridge_compatibility_check', JSON.stringify(eventPayload));
        } catch (error) {}
        window.dispatchEvent(new CustomEvent('ff:fridge-compatibility-check', { detail: eventPayload }));
        if (window.dataLayer && Array.isArray(window.dataLayer)) {
          window.dataLayer.push(eventPayload);
        }
        updateCartCompatibilityAttributes(eventPayload);
        if (!compatibilityLogEndpoint || !window.fetch) {
          return;
        }
        fetch(compatibilityLogEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(eventPayload),
          credentials: 'omit',
          keepalive: true
        }).catch(() => {});
      };
      const addRecommendedFilterToCart = async (addButton) => {
        const variantId = addButton.dataset.variantId || '';
        if (!variantId || !window.fetch) {
          return;
        }
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const originalText = addButton.textContent;
        addButton.disabled = true;
        addButton.textContent = 'Adding...';
        try {
          const model = addButton.dataset.model || '';
          const modelBrand = addButton.dataset.brand || compat.dataset.applianceBrand || '';
          const filterSku = addButton.dataset.sku || '';
          const item = {
            id: variantId,
            quantity: 1
          };
          if (model) {
            item.properties = {
              'Fridge model': model,
              '_fridge_brand': modelBrand.toLowerCase().trim(),
              '_fridge_appliance': `${modelBrand} ${model}`.trim(),
              '_compatibility_status': 'matched_different_filter',
              '_compatibility_filter_sku': filterSku
            };
            await updateCartApplianceAttributes(buildApplianceData(model, modelBrand, { sku: filterSku }));
          }
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: [item] }),
            credentials: 'same-origin'
          });
          if (!response.ok) {
            throw new Error('Cart add failed');
          }
          // Normalised with every other add path: the 'product:added' event below drives the
          // shared open-on-add handler in cart-count-updater.js (count increase → refetch via
          // SLIDECART_UPDATE → open), so the compatibility checker add now behaves exactly
          // like a normal Add to Basket — no bespoke open logic here.
          document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: 1 } }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          addButton.textContent = 'Added';
          setTimeout(() => {
            addButton.disabled = false;
            addButton.textContent = originalText;
          }, 1800);
        } catch (error) {
          addButton.disabled = false;
          addButton.textContent = 'Try again';
        }
      };
      if (result) {
        result.addEventListener('click', (event) => {
          const addButton = event.target.closest('[data-ff-compat-add]');
          if (!addButton) {
            return;
          }
          addRecommendedFilterToCart(addButton);
        });
      }
      if (productForm) {
        productForm.addEventListener('submit', () => {
          if (confirmedApplianceModel) {
            setApplianceFields(confirmedApplianceData || buildApplianceData(confirmedApplianceModel));
          }
        });
      }
      button.addEventListener('click', async () => {
        const model = (input.value || '').trim();
        const query = normalizeComparableCode(model);
        const legacyQuery = model.replace(/[^a-z0-9]/gi, '').toLowerCase();
        const haystack = `${compat.dataset.productTags || ''}|${compat.dataset.fitCopy || ''}`.replace(/[^a-z0-9|]/gi, '').toLowerCase();
        if (!query) {
          clearApplianceFields();
          setResult('Enter a model number to check compatibility.', 'is-warning');
          return;
        }
        if (query.length < 4) {
          clearApplianceFields();
          setResult('Enter the full model number so we can check it accurately.', 'is-warning');
          return;
        }

        await filterIndexReady;
        const modelMatch = findCompatibleModel(model);
        if (modelMatch) {
          const matchedModel = modelMatch.entry.model || modelMatch.value || model;
          const modelBrand = modelMatch.entry.brand || compat.dataset.applianceBrand || '';
          const applianceData = buildApplianceData(matchedModel, modelBrand);
          confirmedApplianceModel = matchedModel;
          confirmedApplianceData = applianceData;
          setApplianceFields(applianceData);
          updateCartApplianceAttributes(applianceData);
          logCompatibilitySubmission({
            entered_model: model,
            matched_model: matchedModel,
            appliance_brand: modelBrand,
            result: modelMatch.type === 'exact' || normalizeComparableCode(model) === normalizeComparableCode(matchedModel) ? 'confirmed_current_filter' : 'possible_current_filter_match'
          });
          if (modelMatch.type === 'exact' || normalizeComparableCode(model) === normalizeComparableCode(matchedModel)) {
            setResultHtml(
              buildStatusHtml('Correct filter confirmed', `This filter is compatible with fridge model <strong>${escapeHtml(matchedModel)}</strong>. You can add it to basket with confidence.`),
              'is-compatible'
            );
          } else {
            setResultHtml(
              buildStatusHtml('Possible model match', `Do you mean <strong>${escapeHtml(matchedModel)}</strong>? If so, this filter is compatible.`),
              'is-compatible'
            );
          }
        } else {
          const filterMatch = findFilterMatch(model);
          if (filterMatch && filterMatch.product.productId === currentProductId) {
            const matchedModel = filterMatch.entry.model || filterMatch.value || model;
            const modelBrand = filterMatch.entry.brand || compat.dataset.applianceBrand || '';
            const applianceData = buildApplianceData(matchedModel, modelBrand, filterMatch.product);
            confirmedApplianceModel = matchedModel;
            confirmedApplianceData = applianceData;
            setApplianceFields(applianceData);
            updateCartApplianceAttributes(applianceData);
            logCompatibilitySubmission({
              entered_model: model,
              matched_model: matchedModel,
              appliance_brand: modelBrand,
              result: 'possible_current_filter_match'
            });
            setResultHtml(
              buildStatusHtml('Possible model match', `Do you mean <strong>${escapeHtml(matchedModel)}</strong>? If so, this filter is compatible.`),
              'is-compatible'
            );
          } else if (filterMatch && filterMatch.product.productId !== currentProductId) {
            const matchedModel = filterMatch.entry.model || filterMatch.value || model;
            const isExactFilterMatch = filterMatch.type === 'exact' || normalizeComparableCode(model) === normalizeComparableCode(matchedModel);
            const modelBrand = filterMatch.entry.brand || compat.dataset.applianceBrand || '';
            clearApplianceFields();
            logCompatibilitySubmission({
              entered_model: model,
              matched_model: matchedModel,
              appliance_brand: modelBrand,
              result: isExactFilterMatch ? 'matched_different_filter' : 'possible_different_filter_match',
              suggested_product_id: filterMatch.product.productId,
              suggested_variant_id: filterMatch.product.variantId,
              suggested_product_title: filterMatch.product.title,
              suggested_product_url: filterMatch.product.url,
              suggested_filter_sku: filterMatch.product.sku
            });
            setResultHtml(buildCorrectFilterHtml(filterMatch.product, matchedModel, !isExactFilterMatch, modelBrand), 'is-warning');
          } else if (!compatibleModelEntries.length && legacyQuery && haystack.includes(legacyQuery)) {
            const applianceData = buildApplianceData(model, compat.dataset.applianceBrand || '');
            confirmedApplianceModel = model;
            confirmedApplianceData = applianceData;
            setApplianceFields(applianceData);
            updateCartApplianceAttributes(applianceData);
            logCompatibilitySubmission({
              entered_model: model,
              matched_model: model,
              appliance_brand: compat.dataset.applianceBrand || '',
              result: 'legacy_current_filter_match'
            });
            setResult('This filter looks compatible with your model.', 'is-compatible');
          } else {
            clearApplianceFields();
            logCompatibilitySubmission({
              entered_model: model,
              matched_model: '',
              appliance_brand: '',
              result: 'no_match'
            });
            setResult('We could not confirm this model. Please contact us before ordering.', 'is-incompatible');
          }
        }
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          button.click();
        }
      });
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-fridge-filter-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ff-fridge-tabs').forEach((section) => {
    const tabButtons = section.querySelectorAll('.ff-fridge-tabs__tablist button');
    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        tabButtons.forEach((tab) => {
          tab.classList.remove('is-active');
          tab.setAttribute('aria-selected', 'false');
        });
        section.querySelectorAll('.ff-fridge-tabs__panel').forEach((panel) => {
          panel.hidden = true;
          panel.classList.remove('is-active');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');
        const panel = section.querySelector(`#${button.getAttribute('aria-controls')}`);
        if (panel) {
          panel.hidden = false;
          panel.classList.add('is-active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
